module.exports = {"screen-xs-min":"0px","screen-xs-max":"375px","screen-sm-min":"376px","screen-sm-max":"767px","screen-md-min":"768px","screen-md-max":"992px","screen-lg-min":"993px","screen-lg-max":"1280px","screen-gt-lg":"1281px"}


//////////////////
// WEBPACK FOOTER
// ./src/scss/variables.json
// module id = 2078
// module chunks = 0